module.exports = __webpack_public_path__ + "static/media/Corteva_Do_More_with_Less-desktop.6c507ac0.jpg";